<!-- src/components/VuewDropdown.vue -->

<template>
    <div class="dropdown">
        <div class="dropdown-button">{{ title }}<span class="caret"></span></div>
        <ul class="dropdown-menu">
            <slot></slot>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['title'],

    methods: {

    }
}
</script>

<style>
.dropdown {
    position: relative;
    display: inline-block;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    color: #969696;
    letter-spacing: 0;
}

.dropdown-button {
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
    padding: 10px 15px;
}

.dropdown-button .caret {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 4px;
    margin-right: -5px;
    vertical-align: middle;
    border-top: 4px dashed;
    border-right: 4px solid transparent;
    border-left: 4px solid transparent;
}

.dropdown-menu {
    background: #FFF;
    position: absolute;
    top: 100%;
    margin-top: 0px;
    width: 100%;
    min-width: 150px;
    right: -5px;
    border: 1px solid #DDD;
    display: none;
    font-size: 14px;
    padding: 5px;
    border-radius: 10px;
    z-index: 999;
    box-shadow: 0 5px 10px 0 rgba(0,0,0,0.10);
}

.dropdown-menu li {
    list-style: none;
    text-align: left;
}

.dropdown-menu li a {
    list-style: none;
    font-size: 13px;
    color: #969696;
    padding: 10px;
    text-align: left;
    display: flex;
    text-decoration: none;
}

.dropdown-menu li:first-child a {
    border-radius: 9px 9px 0px 0px;
}

.dropdown-menu li:last-child a {
    border-radius: 0px 0px 9px 9px;
}

.dropdown:hover .dropdown-menu {
    display: block;
}

.dropdown-menu li a:hover {
    background: #F9F9F9;
    color: var(--primary-color1);
}

.dropdown-menu li .nav-icon {
    margin-left: 3px;
    margin-right: 10px;
}

.dropdown-menu:after,
.dropdown-menu:before {
    bottom: 100%;
    left: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}

.dropdown-menu:after {
    border-color: rgba(255, 255, 255, 0);
    border-bottom-color: #FFF;
    border-width: 7px;
    margin-left: -25px;
}

.dropdown-menu:before {
    border-color: rgba(221, 221, 221, 0);
    border-bottom-color: #ddd;
    border-width: 8px;
    margin-left: -26px;
}
</style>
